import React from 'react'
import PropTypes from 'prop-types'
import { trimSpacesAndCommas, stringOrEmpty } from 'shared/helper'

const DEFAULT_OPENING_TEXT = "Prepared for"

const GreetingText = ({lead, config}) => {
  const name = stringOrEmpty(lead.name)
  const lastName = stringOrEmpty(lead.last_name)
  const company = stringOrEmpty(lead.company)

  if (lead.group_user || lead.anon_guest) return null
  if (!name && !lastName) return null

  const details = trimSpacesAndCommas(`${name} ${lastName}, ${company}`)
  const openingText = config.opening_text || DEFAULT_OPENING_TEXT
  return <span className='greeting-text'>{`[${openingText} ${details}]`}</span>
}

GreetingText.propTypes = {
  lead: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired
}

export default GreetingText
